export enum FeatureActionTypes {
  GET_FEATURES = 'FEATURES/GET_FEATURES',
  GET_FEATURES_SUCCESS = 'FEATURES/GET_FEATURES_SUCCESS',
  GET_FEATURES_ERROR = 'FEATURES/GET_FEATURES_ERROR'
}
